module.exports = __webpack_public_path__ + "img/checkbox_sprite_grey_disabled.45f3c09f.svg";